<template>
  <div>
    <div
        v-for="message in messages"
        :key="message.messageId"
    >
      <v-card
          @contextmenu="e => showContextMenu(e, message)"
          flat
          @dragstart="e => dragStarted(e, message)"
          :draggable="selectMultiple ? selectedMessageMessageIds.has(message.messageId) : true"
          @click="messageClicked(message)"
          class=""
      >
        <div
            :class="selectedMessageMessageIds.has(message.messageId) ? 'selectedMessage' : (!parseInt(message.status) ? 'unread' : 'read')"
            style="overflow-x: hidden; cursor: pointer"
            class="c-d-flex c-align-content-stretch"
        >
          <!--          {-->
          <!--          "summary": "Check how healthy you are! ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ‌ ",-->
          <!--          "sentDateInGMT": "1743112695000",-->
          <!--          "calendarType": 0,-->
          <!--          "subject": "Juan, what can you do in 90 seconds? ⏲️",-->
          <!--          "messageId": "1743087504640018400",-->
          <!--          "flagid": "flag_not_set",-->
          <!--          "status2": "0",-->
          <!--          "priority": "3",-->
          <!--          "hasInline": "true",-->
          <!--          "toAddress": "&lt;juan@zabackup.co.za&gt;",-->
          <!--          "folderId": "1284273000000008014",-->
          <!--          "ccAddress": "Not Provided",-->
          <!--          "hasAttachment": "0",-->
          <!--          "size": "43824",-->
          <!--          "sender": "multiply@momentum.co.za",-->
          <!--          "receivedTime": "1743087504569",-->
          <!--          "fromAddress": "multiply@momentum.co.za",-->
          <!--          "status": "1",-->
          <!--          "date": "2025-03-27T14:58:15.000Z",-->
          <!--          "taskIds": []-->
          <!--          }-->
          
          <div style="overflow-x: hidden" class="c-flex-grow-1 ml-1">
            <v-layout column>
              <v-flex shrink style="overflow-x: hidden">
                <v-layout row align-center>
                  <v-flex
                      xs12
                      class="body-1 text-truncate"
                      style="white-space: pre; overflow-x: hidden"
                      v-if="message.sender"
                      :style="!message.isRead ? 'font-weight: 500' : null"
                      v-html="message.sender"
                  >
                  </v-flex>
                  <v-flex shrink class="pr-1">
                                        <span style="white-space: nowrap" class="greyType--text caption">
                                            {{ message.viewDate }}
                                        </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink style="overflow-x: hidden">
                <v-layout row style="overflow-x: hidden" align-center>
                  <v-flex xs12 style="overflow-x: hidden">
                    <div style="overflow-x: hidden" class="text-truncate" v-if="message.subject">
                      <span class="body-1" style="white-space: pre;" v-html="message.subject"></span>
                    </div>
                    <div style="overflow-x: hidden" class="text-truncate">
                      <span class="caption greyType--text" style="white-space: pre;" v-html="message.summary"></span>
                    </div>
                  </v-flex>
                  <!--                  <v-flex shrink>-->
                  <!--                    <v-tooltip top>-->
                  <!--                      <v-icon-->
                  <!--                          color="red"-->
                  <!--                          slot="activator"-->
                  <!--                          style="cursor: pointer"-->
                  <!--                          class="pa-1"-->
                  <!--                          @click="archiveMessageFn(message)"-->
                  <!--                          :disabled="typeof userPrincipal.default == 'undefined'"-->
                  <!--                      >-->
                  <!--                        archive-->
                  <!--                      </v-icon>-->
                  <!--                      <span>Archive Message</span>-->
                  <!--                    </v-tooltip>-->
                  <!--                  </v-flex>-->
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          
          <div class="" style="min-width: 4px; opacity: 1;" :style="{background: message.taskIds.length ? 'var(--v-tGreen-base)' : undefined}">
            <!--Linked To Task-->
          </div>
        </div>
        <v-progress-linear
            v-if="loadingMessageIds.includes(message.messageId)"
            indeterminate
            height="3"
            class="pa-0 ma-0"
            co
        ></v-progress-linear>
        <v-divider></v-divider>
      </v-card>
    </div>
    
    <div
        v-if="!messages.length && showLoading"
        class="text-xs-center"
    >
      <v-btn
          flat
          color="secondary"
          :loading="true"
          :disabled="true"
      />
    </div>
    <div
        v-else-if="allowLoadMore"
        class="text-xs-center"
    >
      <v-btn
          flat
          color="secondary"
          :loading="showLoading"
          :disabled="showLoading"
          @click="loadMessages(true)"
      >
        Load More
      </v-btn>
    </div>
    <v-menu
        v-if="contextMessage"
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
    >
      
      <div style="width: 350px; background: var(--card-back); cursor: pointer">
        <v-card >
          <v-list class="py-0 my-0">
            <v-list-tile
                v-if="selectedMessages.length"
                ripple
                @click="contextSelectMultiple"
            >
              <div class="c-d-flex c-align-center">
                <div class="mr-3">
                  <v-icon>{{ selectMultiple ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                </div>
                <div class="text-truncate">
                  Select Multiple
                </div>
              </div>
            </v-list-tile>
            
            <v-list-tile
                ripple
                @click="eventBus.$emit('linkZohoMail', true)"
            >
              <div class="c-d-flex c-align-center">
                <div class="mr-3">
                  <v-icon small>link</v-icon>
                </div>
                <div class="text-truncate">
                  Link to task
                </div>
              </div>
            </v-list-tile>
            <v-list-tile
                ripple
                @click="() => createTaskClick()"
            >
              <div class="c-d-flex c-align-center">
                <div class="mr-3">
                  <v-icon small>add</v-icon>
                </div>
                <div class="text-truncate">
                  Create task
                </div>
              </div>
            </v-list-tile>
          </v-list>
          <div v-for="taskId in contextMessage.taskIds">
            <task-loading-container
                v-if="loadingTasks.includes(taskId)"
                :task-id="taskId"
            />
            <task-container
                v-else-if="tasks[taskId]"
                :userInfo="userInfo"
                :task="tasks[taskId]"
                :taskBar="false"
                :showNav="false"
                @taskSelected="() => eventBus.$emit('gotoTask', tasks[taskId])"
            />
            
          </div>
        </v-card>
      </div>
    </v-menu>
    
    
    
  </div>
</template>

<script>
import {codeBaseMixin} from "../../../../codeBaseMixin";
import {format} from "date-fns";
import {feed} from "@/feedSocket";
import TaskLoadingContainer from "@/components/TaskContainer/TaskLoadingContainer.vue";
import TaskContainer from "@/components/TaskContainer/TaskContainer.vue";
import {eventBus} from "@/main";

export default {
  components: {TaskContainer, TaskLoadingContainer},
  mixins: [codeBaseMixin],
  props: {
    userInfo: Object,
    selectedAddress: Object,
    selectedLabel: Object,
    searchOptions: Object,
    getTaskHeader: Function,
    selectedMessage: Object,
  },
  data() {
    return {
      eventBus,
      showLoading: false,
      messages: [],
      showLoadMore: false,
      selectedMessages: [],
      selectMultiple: false,
      loadingTasks: [],
      tasks: [],
      contextMessage: null,
      showMenu: false,
      x: 0,
      y: 0,
      loadingMessageIds: [],
      allowLoadMore: false,
    }
  },
  watch: {
    viewKey: {
      immediate: true,
      handler(val) {
        this.messages = []
        this.selectedMessages = []
        this.loadMessages();
      }
    },
    selectMultiple(val) {
      if (!val) {
        this.selectedMessages = []
      }
    },
    messages(val) {
      const messageIdSet = new Set(val.map(v => v.messageId))
      this.selectedMessages = this.selectedMessages.filter(v => messageIdSet.has(v.messageId))
    },
    selectedMessages: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal?.length) {
          this.selectMultiple = false
          eventBus.$emit('linkZohoMail', false)
        }
        
        let newArr = newVal || []
        let oldArr = oldVal || []

        if (newArr.length && JSON.stringify(newArr) === JSON.stringify(oldArr)) return

        let added = newArr.find(v => !oldArr.includes(v))
        if (added) return this.$emit('update:selectedMessage', added)
        this.$emit('update:selectedMessage', null)
      }
    }
  },
  mounted() {
    eventBus.$on('zohoLinkToTaskSelected', this.linkMailsToTask)
    eventBus.$on('createTaskZohoRun', this.createTaskClick)
    eventBus.$on('zohoShowMessageLoading', this.zohoShowMessageLoading)
    feed.on('zohoMessageUpdate', this.zohoMessageUpdate)
    feed.on('zohoMessagesMove', this.zohoMessagesMove)
  },
  beforeDestroy() {
    eventBus.$off('zohoLinkToTaskSelected', this.linkMailsToTask)
    eventBus.$off('createTaskZohoRun', this.createTaskClick)
    eventBus.$off('zohoShowMessageLoading', this.zohoShowMessageLoading)
    feed.off('zohoMessageUpdate', this.zohoMessageUpdate)
    feed.on('zohoMessagesMove', this.zohoMessagesMove)
    this.$emit('update:selectedMessage', null)
  },
  methods: {
    
    zohoShowMessageLoading({messageId, value}) {
      if (value) {
        this.loadingMessageIds.push(messageId)
      } else {
        this.loadingMessageIds = this.loadingMessageIds.filter(v => v !== messageId)
      }
    },
    
    createTaskClick(qt) {
      eventBus.$emit('createTaskZoho', {tokenId: this.selectedAddress.tokenId, messages: this.selectedMessages, qt});
      eventBus.$emit('linkZohoMail', false);
    },
    
    async linkMailsToTask(task) {
      eventBus.$emit('linkZohoMail', false)
      const linkMessages = [...this.selectedMessages.filter(v => !v.taskIds.includes(task.id))]
      let errors = 0
      for (const message of linkMessages) {
        try {
          this.loadingMessageIds.push(message.messageId)
          const updatedMessage = await this.$newReq('POST', 'zoho/messages/linkToTask', { tokenId: this.selectedAddress.tokenId, taskId: task, message: message })
          Object.assign(message, updatedMessage)
        } catch (e) {
          console.log(e)
          this.$snack.networkError()
          errors++
        } finally {
          this.loadingMessageIds = this.loadingMessageIds.filter(v => v !== message.messageId)
        }
      }
      
      if (!errors)
        this.$snack.info(`Linked message${linkMessages.length > 1 ? 's' : '' } to task`)
    },
    
    contextSelectMultiple() {
      this.selectMultiple = !this.selectMultiple
      
      if (this.selectMultiple) {
        if (!this.selectedMessageMessageIds.has(this.contextMessage.messageId))
          this.selectedMessages = this.selectedMessages.concat(this.contextMessage)
      } else {
        this.selectedMessages = [this.contextMessage]
      }
    
    },
    
    showContextMenu(e, message) {
      
      if (!this.selectedMessages.length) {
        this.selectedMessages = [message]
      } else if (!this.selectMultiple) {
        this.selectedMessages = [message]
      } else if (this.selectMultiple && !this.selectedMessageMessageIds.has(message.messageId)) {
        this.selectedMessages = this.selectedMessages.concat(message)
      } else if (this.selectMultiple && !this.selectedMessageMessageIds.has(message.messageId)) {
        this.selectedMessages = this.selectedMessages.concat(message)
      }
      
      console.log(
        'Message',
        message,
        'Selected',
      )
      
      this.contextMessage = message
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
      this.refreshTasks(message.taskIds)
    },
    
    async refreshTasks(taskIds) {
      for (const taskId of taskIds) {
        try {
          if (!this.tasks[taskId]) {
            console.log('HERE')
            this.loadingTasks.push(taskId)
            this.tasks[taskId] = await this.getTaskHeader(taskId)
            this.loadingTasks = this.loadingTasks.filter(v => v !== taskId)
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    
    dragStarted(e, message) {
      
      if (this.selectMultiple) {
        if (!this.selectedMessageMessageIds.has(message.messageId))
          this.selectedMessages = this.selectedMessages.concat(message)
      } else {
        this.selectedMessages = [message]
      }
      
      
      e.dataTransfer.setData('text', JSON.stringify({
        type: 'zohoMessages',
        data: this.selectedMessages
      }));
    },
    
    zohoMessagesMove(messages) {
      messages.forEach(message => {
        this.zohoMessageUpdate(message)
      })
    },
    
    zohoMessageUpdate(message) {
      
      const searchStructure = [
        this.searchOptions.searchText || '',
        this.searchOptions.from || '',
        this.searchOptions.to || '',
        this.searchOptions.subject || '',
        this.searchOptions.hasWords || '',
        this.searchOptions.noWords || '',
        this.searchOptions.hasAttachment ? '1' : '0',
        this.searchOptions.starred ? '1' : '0',
      ].join('');
      
      if (!this.selectedLabel?.folderId && searchStructure === '00') {
        return;
      }
      
      const inSearch = searchStructure !== '00'
      
      if (!inSearch) {
        
        console.log(message, this.selectedLabel, message.folderId === this.selectedLabel?.folderId)
        
        if (message.folderId === this.selectedLabel?.folderId) {
          // Message Is For THis Folder
          let listMessage = this.messages.find(v => v.messageId === message.messageId)
          
          if (!listMessage) {
            this.messages = [...this.messages, message].map(v => ({
              ...v,
              date: new Date(v.date),
              viewDate: format(new Date(v.date), 'D MMM YY')
            })).sort((a, b) => b.date - a.date)
            
            listMessage = message
          } else {
            Object.assign(listMessage, message)
          }
          
          console.log('Set HERE')
        } else {
          console.log('remove Here')
          // Remove From List
          this.messages = this.messages.filter(v => v.messageId !== message.messageId)
        }
      }
      
      
    },
    
    messageClicked(message) {
      this.markMessageAsRead(message)
      
      if (this.selectMultiple)
        if (this.selectedMessageMessageIds.has(message.messageId))
          this.selectedMessages = this.selectedMessages.filter(v => v !== message)
        else
          this.selectedMessages = this.selectedMessages.concat(message);
      else
        this.selectedMessages = this.selectedMessageMessageIds.has(message.messageId) ? [] : [message];
    },
    
    async markMessageAsRead(message) {
      try {
        message.status = "1";
        await this.$newReq('POST', 'zoho/messages/markAsRead', { tokenId: this.selectedAddress.tokenId, message: message })
      } catch (e) {
        console.log(e)
      }
    },
    
    async loadMessages(noMessagesSnack = false) {
      try {
        this.showLoading = true;
        const searchStructure = [
          this.searchOptions.searchText || '',
          this.searchOptions.from || '',
          this.searchOptions.to || '',
          this.searchOptions.subject || '',
          this.searchOptions.hasWords || '',
          this.searchOptions.noWords || '',
          this.searchOptions.hasAttachment ? '1' : '0',
          this.searchOptions.starred ? '1' : '0',
        ].join('');
        if (!this.selectedLabel?.folderId && searchStructure === '00') {
          return;
        }
        
        const inSearch = searchStructure !== '00'
        
        const res = !inSearch
            ? await this.$newReq('POST', 'zoho/messages/folderId', {
              tokenId: this.selectedAddress.tokenId,
              folderId: this.selectedLabel.folderId,
              skip: this.messages.length,
            })
            : await this.$newReq('POST', 'zoho/messages/search', {
              tokenId: this.selectedAddress.tokenId,
              searchOptions: this.searchOptions,
              skip: this.messages.length,
            })
        
        this.messages = [...this.messages, ...res]
            .map(v => ({
              ...v,
              date: new Date(v.date),
              viewDate: format(new Date(v.date), 'D MMM YY')
            }))
            .filter((v, i, a) => a.findIndex(vv => vv.messageId === v.messageId) === i)
            .sort((a,b) => b.date - a.date)
        
        if (!res.length && noMessagesSnack) {
          this.$snack.info('No more messages')
        }
        
        this.allowLoadMore = res.length >= 20
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.showLoading = false;
      }
    },
    loadMoreFn() {
    
    }
  },
  computed: {
    selectedMessageMessageIds() {
      return new Set(this.selectedMessages.map(v => v.messageId))
    },
    viewKey() {
      return [
        this.selectedLabel?.folderId || '',
        this.searchOptions.searchText || '',
        this.searchOptions.from || '',
        this.searchOptions.to || '',
        this.searchOptions.subject || '',
        this.searchOptions.hasWords || '',
        this.searchOptions.noWords || '',
        this.searchOptions.hasAttachment ? '1' : '0',
        this.searchOptions.starred ? '1' : '0',
      ].join('')
    },
    
    messagesAdditional() {
      return this.messages.map((message) => {
        message.displayDate = this.getShortDate(message.date);
        message.snippetDisplay = message.snippet != null ? message.snippet.replace(/\n/g, " ") : '';
        if (this.movingMessage && this.dragMessage != null && this.dragMessage.id == message.id) {
          message.showLoading = true;
        } else {
          message.showLoading = false;
        }
        return message
      })
    }
  }
}
</script>

<style scoped>
.selectedMessage {
  border-left: 4px solid var(--v-secondary-base);
  background-color: var(--selected-item);
}

.read {
  border-left: 4px solid rgba(0, 0, 0, 0);
  background: var(--hover-item-background);
}

.unread {
  border-left: 4px solid var(--v-primary-base);
}

.read:hover {
  border-left: 4px solid rgba(0, 0, 0, 0);
  background-color: var(--hover-item-background);
}

.unread:hover {
  background-color: var(--hover-item-background);
}
</style>
